import { render, staticRenderFns } from "./hot-m.vue?vue&type=template&id=20eb0424&scoped=true&"
import script from "./hot-m.vue?vue&type=script&lang=js&"
export * from "./hot-m.vue?vue&type=script&lang=js&"
import style0 from "./hot-m.vue?vue&type=style&index=0&id=20eb0424&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eb0424",
  null
  
)

export default component.exports